module.exports = __webpack_public_path__ + "static/media/calendar.a6cbd951.svg";